import React, { useState } from "react";
import * as Yup from "yup";
import { useCartao } from "../../hooks/cartao";
import {
  validacoesListar,
  IValidacoesListarResponse,
  validacoesConfirmar,
  IValidacoesConfirmarResponse,
  enviarToken,
  confirmarToken,
  tokenTextoMensagem,
} from "../../services/cartao";
import { Formik, Form, Field } from "formik";
import { AiOutlineCheckCircle, AiOutlineWarning } from "react-icons/ai";
import { VscCreditCard } from "react-icons/vsc";
import { BsLockFill } from "react-icons/bs";
import { FiSend } from "react-icons/fi";

import { TailSpin } from "react-loading-icons";

interface IValuesToken {
  telefone: string;
  email: string;
  alteraCelular: boolean;
  alteraEmail: boolean;
}

interface IAtualizaToken {
  telefone?: string;
  email?: string;
}

const ListarCartoes: React.FC = () => {
  const {
    tTelefone,
    tEmail,
    codigo,
    passo,
    erro,
    dadosCartoes,
    celularToken,
    emailToken,
    carregarBeneficiario,
    alteraPasso,
    alteraErro,
    alteraCodigo,
    alteraTokenTelefone,
    alteraTokenEmail,
    alteraQtCartoes,
    alteraDadosCartoes,
    alteraCartaoCpf,
    alteraCelularToken,
    alteraEmailToken,
    alteraCarregarBeneficiario,
  } = useCartao();
  const [validacao, setValidacao] = useState<IValidacoesListarResponse>({
    id: "",
    tipo: "",
    texto: "",
    error: "",
    msg: "",
  });
  const [showToken, setShowToken] = useState<boolean>(false);
  const [showConfirmToken, setShowConfirmToken] = useState<boolean>(false);
  const [loadingToken, setLoadingToken] = useState<boolean>(false);
  const [erroToken, setErroToken] = useState<string>("");
  const [sucessoToken, setSucessoToken] = useState<string>("");
  const [erroTokenSms, setErroTokenSms] = useState<string>("");
  const [erroTokenEmail, setErroTokenEmail] = useState<string>("");
  const [sucessoTokenSms, setSucessoTokenSms] = useState<string>("");
  const [sucessoTokenEmail, setSucessoTokenEmail] = useState<string>("");
  const [showValidacao, setShowValidacao] = useState<boolean>(false);
  const [loadingValidacao, setLoadingValidacao] = useState<boolean>(false);
  const [resultValidacao, setresultValidacao] =
    useState<IValidacoesConfirmarResponse>();
  const [erroValidacao, setErroValidacao] = useState<string>("");
  const [tokenSmsLoading, setTokenSmsLoading] = useState<boolean>(false);
  const [tokenSms, setTokenSms] = useState<string>("");
  const [tokenEmailLoading, setTokenEmailLoading] = useState<boolean>(false);
  const [tokenEmail, setTokenEmail] = useState<string>("");
  const [tokenEnviado, setTokenEnviado] = useState<boolean>(false);
  const [tokenMensagem, setTokenMensagem] = useState<string>("");

  const selecionaCodigo = async (codigo: string) => {
    setLoadingValidacao(true);
    limpar();

    const result = await validacoesListar({
      codigo: codigo,
      tipo: "BENEFICIARIO",
    });
    if (result.error) {
      alteraPasso(1);
      alteraCodigo("");
      alteraErro(result.msg);
      setShowValidacao(false);
    } else {
      let tokenMensagem = await tokenTextoMensagem();
      setTokenMensagem(tokenMensagem);

      alteraCodigo(codigo);
      setShowValidacao(true);
      setValidacao(result);
    }
    setLoadingValidacao(false);
  };

  const validationSubmit = async (resposta: string) => {
    setLoadingValidacao(true);
    setErroValidacao("");
    const resultValidacao = await validacoesConfirmar({
      codigo: codigo,
      id: validacao.id,
      local: "DESBLOQUEIO",
      tipo: "BENEFICIARIO",
      valor: resposta,
    });
    if (resultValidacao.error) {
      setErroValidacao(resultValidacao.msg);
      selecionaCodigo(codigo);
    } else {
      setresultValidacao(resultValidacao);
      setShowValidacao(false);
      setShowToken(true);
      alteraCelularToken(resultValidacao.telefone);
      alteraEmailToken(resultValidacao.email);
    }
    setLoadingValidacao(false);
  };

  const tokenSchema = Yup.object().shape({
    telefone: Yup.string().when("alteraCelular", {
      is: true,
      then: Yup.string().required("Informe o número do telefone"),
    }),
    email: Yup.string()
      .email("Endereço de email inválido")
      .when("alteraEmail", {
        is: true,
        then: Yup.string().required("Informe o endereço do email"),
      }),
  });

  const tokenSubmit = async (values: IValuesToken) => {
    setTokenEnviado(false);
    setLoadingToken(true);
    setErroToken("");
    setSucessoToken("");
    setShowConfirmToken(false);
    // alteraTokenTelefone("");
    // alteraTokenEmail("");
    // setTokenEmail("");
    // setTokenSms("");

    let atualiza: IAtualizaToken = {};
    if (values.alteraCelular) {
      atualiza.telefone = values.telefone;
    }

    if (values.alteraEmail) {
      atualiza.email = values.email;
    }
    let tipo = "email";
    if (sucessoTokenSms) {
      tipo = "email";
    } else {
      tipo = "celular";
    }

    const resultValidacao = await enviarToken({
      tipo: tipo,
      codigo: codigo,
      local: "DESBLOQUEIO",
      novo: "1",
      ...atualiza,
    });
    if (resultValidacao.error) {
      setErroToken(resultValidacao.msg);
      // selecionaCodigo(codigo);
    } else {
      setSucessoToken(resultValidacao.msg);
      setShowConfirmToken(true);
      setTokenEnviado(true);
    }
    setLoadingToken(false);
  };

  const validaTokenSms = async () => {
    if (tTelefone !== "") {
      alteraPasso(2);
    } else {
      setTokenSmsLoading(true);
      setErroTokenSms("");
      setSucessoTokenSms("");
      alteraTokenTelefone("");
      const resultToken = await confirmarToken({
        codigo: codigo,
        local: "DESBLOQUEIO",
        token: tokenSms,
        tipo: "SMS",
      });
      if (resultToken.error) {
        setErroTokenSms(resultToken.msg);
      } else {
        alteraTokenTelefone(tokenSms);
        setSucessoTokenSms(resultToken.msg);
        setShowValidacao(false);
        setShowToken(false);
        alteraPasso(2);
        setSucessoToken("");
        setShowConfirmToken(false);
      }
      setTokenSmsLoading(false);
    }
  };

  const limpar = () => {
    setShowValidacao(false);
    alteraTokenTelefone("");
    alteraTokenEmail("");
    alteraCodigo("");
    setTokenEmail("");
    setTokenSms("");
    setTokenEmailLoading(false);
    setErroTokenSms("");
    setErroTokenEmail("");
    setSucessoTokenSms("");
    setSucessoTokenEmail("");
    setTokenSmsLoading(false);
    setTokenEnviado(false);
    setShowConfirmToken(false);
    setErroToken("");
    setSucessoToken("");
  };

  const cancelar = () => {
    setShowValidacao(false);
    setShowToken(false);
    alteraTokenTelefone("");
    alteraTokenEmail("");
    alteraCodigo("");
    setTokenEmail("");
    setTokenSms("");
    setTokenEmailLoading(false);
    setErroTokenSms("");
    setErroTokenEmail("");
    setSucessoTokenSms("");
    setSucessoTokenEmail("");
    setTokenSmsLoading(false);
    setTokenEnviado(false);
    setShowConfirmToken(false);
    setErroToken("");
    setSucessoToken("");
  };

  const sair = () => {
    setShowValidacao(false);
    setShowToken(false);
    alteraTokenTelefone("");
    alteraTokenEmail("");
    alteraCodigo("");
    setTokenEmail("");
    setErroToken("");
    setSucessoToken("");
    setTokenSms("");
    setTokenEmailLoading(false);
    setErroTokenSms("");
    setErroTokenEmail("");
    setSucessoTokenSms("");
    setSucessoTokenEmail("");
    setTokenSmsLoading(false);
    setTokenEnviado(false);
    alteraPasso(0);
    alteraErro("");
    alteraQtCartoes(0);
    alteraDadosCartoes({});
    alteraCartaoCpf("");
  };

  const phoneMask = (phone: string) => {
    return phone
      .replace(/\D/g, "")
      .replace(/^(\d)/, "($1")
      .replace(/^(\(\d{2})(\d)/, "$1) $2")
      .replace(/(\d{4})(\d{1,5})/, "$1-$2")
      .replace(/(-\d{5})\d+?$/, "$1");
  };

  return (
    <>
      {(passo === 1 || passo === 2) && (
        <section className="text-gray-600 body-font bg-theme2">
          <div className="mx-auto px-5 lg:w-3/6 pt-10">
            <h1 className="lg:pt-10 lg:mb-4 font-normal tracking-tighter text-xl lg:text-3xl text-theme text-center">
              A <b className="font-semibold">Dental Uni</b> se preocupa com
              segurança para que sua única preocupação seja encontrar mais
              motivos para sorrir!
            </h1>

            <p className="mb-8 px-10 py-2 lg:py-0 lg:text-xl tracking-tighter lg:leading-7 text-center text-gray-500 ">
              Por isso, os cartões do beneficiário devem ser desbloqueados antes
              do início do uso do plano odontológico
            </p>
          </div>

          <div className="container px-5 pb-24 mx-auto">
            {erro !== "" && erro !== null && (
              <div className="w-2/4 mx-auto bg-red-600 text-white border border-red-500 rounded-lg shadow-xl my-4 ">
                <div className="flex items-center justify-between px-6 py-2 mx-auto ">
                  <div className="flex">
                    <AiOutlineWarning />
                    <p className="text-sm font-semibold tracking-wide uppercase ">
                      {erro}
                    </p>
                  </div>
                </div>
              </div>
            )}
            {/* <div className="my-5">
              <div className="flex items-end justify-center px-6 py-2 mx-auto">
                <button
                  onClick={() => sair()}
                  title="Fechar"
                  className="text-sm font-semibold tracking-wide uppercase "
                >
                  <AiOutlineCloseCircle size="30" />
                </button>
              </div>
            </div> */}
            {dadosCartoes.map((cartao, key) => {
              return (
                <div key={key + Math.random()} className="my-5">
                  {(cartao.bloqueado == "1" ||
                    cartao.dependentes.length > 0) && (
                    <h1 className="w-full text-center text-xl lg:text-2xl my-10">
                      Cartões do contrato {cartao.cliente}
                    </h1>
                  )}
                  {cartao.dep_maiores && (
                    <div className="mx-auto px-5 lg:w-3/6 mb-10">
                      <div
                        className="bg-yellow-100 border-t-4 border-yellow-500 rounded-b text-yellow-900 px-4 py-3 shadow-md"
                        role="alert"
                      >
                        <div className="flex">
                          <div className="py-1">
                            <svg
                              className="fill-current h-6 w-6 text-yellow-500 mr-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                            </svg>
                          </div>
                          <div>
                            <p className="font-bold">Importante</p>
                            <p className="text-sm">
                              Para desbloqueio de dependentes maiores de 18
                              anos, o mesmo deve acessar e realizar o
                              desbloqueio.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {(cartao.bloqueado === "1" ||
                    cartao.dependentes.length > 0) && (
                    <div className="w-full overflow-auto">
                      <table className="mx-auto table-fixed w-3/4 text-center text-md">
                        <thead>
                          <tr>
                            {cartao.desativado !== "1" && (
                              <th className="bg-gray-200 font-normal w-48">
                                Ações
                              </th>
                            )}
                            <th className="bg-gray-200 font-normal w-36">
                              Status
                            </th>
                            <th className="bg-gray-200 font-normal w-40 lg:w-full">
                              Nome
                            </th>
                            <th className="bg-gray-200 font-normal w-28">
                              Tipo
                            </th>
                            <th className="bg-gray-200 font-normal w-32">
                              CPF
                            </th>
                            <th className="bg-gray-200 font-normal w-48">
                              Nº cartão
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartao.bloqueado === "1" && (
                            <tr>
                              {cartao.desativado !== "1" && (
                                <td className="pr-3">
                                  <div className="flex flex-shrink py-2 items-center justify-between">
                                    <div className="h-8 w-px">
                                      <div className="h-full w-full bg-gray-300"></div>
                                    </div>
                                    {!cartao.bloqueado && (
                                      <a
                                        href={`https://api.dentaluni.com.br/beneficiario/cartao/visualizar/${cartao.codigo}`}
                                        target="_blank"
                                        className="flex text-sm items-center justify-between px-1 py-1 mt-auto font-semibold text-white transition duration-500 ease-in-out transform bg-theme rounded-lg  hover:bg-red-700 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-"
                                        title="Gerar cartão"
                                        rel="noreferrer"
                                      >
                                        <VscCreditCard />
                                        <b className="px-2 font-medium">
                                          Gerar cartão virtual
                                        </b>
                                      </a>
                                    )}
                                    {cartao.bloqueado === "1" &&
                                      cartao.desativado !== "1" && (
                                        <button
                                          disabled={loadingValidacao}
                                          onClick={() => {
                                            alteraCarregarBeneficiario(true);
                                            selecionaCodigo(cartao.codigo);
                                          }}
                                          className="flex text-sm items-center justify-between px-1 py-1 mt-auto font-semibold text-white transition duration-500 ease-in-out transform bg-theme rounded-lg  hover:bg-red-700 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-"
                                          title="Desbloquear"
                                        >
                                          {loadingValidacao ? (
                                            <TailSpin
                                              className="h-8 px-2"
                                              speed="1"
                                            />
                                          ) : (
                                            <BsLockFill />
                                          )}
                                          <b className="px-2 font-medium">
                                            Desbloquear cartão
                                          </b>
                                        </button>
                                      )}
                                  </div>
                                </td>
                              )}
                              <td className="font-semibold">
                                <div className="flex flex-shrink py-2 items-center justify-between">
                                  {cartao.bloqueado !== "1" &&
                                    cartao.desativado !== "1" && (
                                      <div className="text-green-600 w-full text-center">
                                        Desbloqueado
                                      </div>
                                    )}
                                  {cartao.bloqueado === "1" &&
                                    cartao.desativado !== "1" && (
                                      <div className="text-red-600 w-full text-center">
                                        Bloqueado
                                      </div>
                                    )}
                                  {cartao.desativado === "1" &&
                                    cartao.tutelar !== "1" && (
                                      <div className="text-gray-600 w-full text-center">
                                        Desativado
                                      </div>
                                    )}
                                  <div className="h-8 w-px">
                                    <div className="h-full w-full bg-gray-300"></div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="flex flex-shrink py-2 items-center justify-between">
                                  <div className="text-gray-600 w-full text-center px-2">
                                    {cartao.nome}
                                  </div>
                                  <div className="h-8 w-px">
                                    <div className="h-full w-full bg-gray-300"></div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                {cartao.tutelar === "1" && (
                                  <div className="text-gray-600 w-full text-center px-2">
                                    Tutelar
                                  </div>
                                )}
                                {cartao.tutelar !== "1" && (
                                  <div className="text-gray-600 w-full text-center px-2">
                                    {cartao.seq !== "1"
                                      ? "Dependente"
                                      : "Titular"}
                                  </div>
                                )}
                              </td>
                              <td>
                                <div className="flex flex-shrink py-2 items-center justify-between">
                                  <div className="h-8 w-px">
                                    <div className="h-full w-full bg-gray-300"></div>
                                  </div>
                                  <div className="text-gray-600 w-full text-center px-2">
                                    {cartao.cpf}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="flex flex-shrink py-2 items-center justify-between">
                                  <div className="h-8 w-px">
                                    <div className="h-full w-full bg-gray-300"></div>
                                  </div>
                                  <div className="text-gray-600 w-full text-center px-2">
                                    {cartao.cartao}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                          {cartao.dependentes.length > 0 &&
                            cartao.dependentes.map((dependente) => {
                              return (
                                <tr key={key + Math.random()}>
                                  {cartao.desativado !== "1" && (
                                    <td className="pr-3">
                                      <div className="flex flex-shrink py-2 items-center justify-between">
                                        <div className="h-8 w-px">
                                          <div className="h-full w-full bg-gray-300"></div>
                                        </div>
                                        {dependente.bloqueado === "0" &&
                                          dependente.desativado !== "1" && (
                                            <a
                                              href={`https://api.dentaluni.com.br/beneficiario/cartao/visualizar/${cartao.codigo}`}
                                              target="_blank"
                                              className="flex text-sm items-center justify-between px-1 py-1 mt-auto font-semibold text-white transition duration-500 ease-in-out transform bg-theme rounded-lg  hover:bg-red-700 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-"
                                              title="Gerar cartão"
                                              rel="noreferrer"
                                            >
                                              <VscCreditCard />
                                              <b className="px-2 font-medium">
                                                Gerar cartão virtual
                                              </b>
                                            </a>
                                          )}
                                        {dependente.bloqueado === "1" &&
                                          dependente.desativado !== "1" &&
                                          dependente.desbloqueia === true && (
                                            <button
                                              disabled={loadingValidacao}
                                              onClick={() => {
                                                alteraCarregarBeneficiario(
                                                  true
                                                );
                                                selecionaCodigo(
                                                  dependente.codigo
                                                );
                                              }}
                                              className="flex text-sm items-center justify-between px-1 py-1 mt-auto font-semibold text-white transition duration-500 ease-in-out transform bg-theme rounded-lg  hover:bg-red-700 focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-"
                                              title="Desbloquear"
                                            >
                                              {loadingValidacao ? (
                                                <TailSpin
                                                  className="h-8 px-2"
                                                  speed="1"
                                                />
                                              ) : (
                                                <BsLockFill />
                                              )}
                                              <b className="px-2 font-medium">
                                                Desbloquear cartão
                                              </b>
                                            </button>
                                          )}
                                        {dependente.desbloqueia === false && (
                                          <button
                                            disabled
                                            className="flex text-sm items-center justify-between px-1 py-1 mt-auto font-semibold text-white transition duration-500 ease-in-out transform bg-gray-500 rounded-lg  focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-"
                                            title="Desbloquear"
                                          >
                                            <BsLockFill />
                                            <b className="px-2 font-medium">
                                              Desbloquear cartão
                                            </b>
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  )}
                                  <td className="font-semibold">
                                    <div className="flex flex-shrink py-2 items-center justify-between">
                                      {dependente.bloqueado !== "1" &&
                                        dependente.desativado !== "1" && (
                                          <div className="text-green-600 w-full text-center">
                                            Desbloqueado
                                          </div>
                                        )}
                                      {dependente.bloqueado === "1" &&
                                        dependente.desativado !== "1" && (
                                          <div className="text-red-600 w-full text-center">
                                            Bloqueado
                                          </div>
                                        )}
                                      {dependente.desativado === "1" && (
                                        <div className="text-gray-600 w-full text-center">
                                          Desativado
                                        </div>
                                      )}
                                      <div className="h-8 w-px">
                                        <div className="h-full w-full bg-gray-300"></div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="flex flex-shrink py-2 items-center justify-between">
                                      <div className="text-gray-600 w-full text-center px-2">
                                        {dependente.nome}
                                      </div>
                                      <div className="h-8 w-px">
                                        <div className="h-full w-full bg-gray-300"></div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-gray-600 w-full text-center px-2">
                                      Dependente
                                    </div>
                                  </td>
                                  <td>
                                    <div className="flex flex-shrink py-2 items-center justify-between">
                                      <div className="h-8 w-px">
                                        <div className="h-full w-full bg-gray-300"></div>
                                      </div>
                                      <div className="text-gray-600 w-full text-center px-2">
                                        {dependente.cpf}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="flex flex-shrink py-2 items-center justify-between">
                                      <div className="h-8 w-px">
                                        <div className="h-full w-full bg-gray-300"></div>
                                      </div>
                                      <div className="text-gray-600 w-full text-center px-2">
                                        {dependente.cartao}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      )}

      {showValidacao && passo === 1 && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center lg:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <Formik
                initialValues={{
                  resposta: "",
                }}
                onSubmit={async (values, { setSubmitting }) => {
                  await validationSubmit(values.resposta);
                  setSubmitting(false);
                  values.resposta = "";
                }}
              >
                {({ errors, touched, isSubmitting }: any) => (
                  <Form className="w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 text-red-600 sm:mx-0 sm:h-10 sm:w-10">
                          <AiOutlineWarning size="50%" />
                        </div>
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <h3
                            className="text-lg leading-6 font-medium text-gray-900"
                            id="modal-title"
                          >
                            Validar dados
                          </h3>
                          <div className="mt-2">
                            {erroValidacao !== "" && erroValidacao !== null && (
                              <div className="w-full mx-auto bg-red-600 text-white border border-red-500 rounded-lg shadow-xl my-4 ">
                                <div className="flex items-center justify-between px-6 py-2 mx-auto ">
                                  <div className="flex">
                                    <AiOutlineWarning />
                                    <p className="text-sm font-semibold tracking-wide uppercase ">
                                      {erroValidacao}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              {validacao?.texto}
                            </p>
                          </div>
                          <div className="mt-2">
                            <Field
                              id="resposta"
                              name="resposta"
                              placeholder=""
                              className="w-full px-4 py-2 mt-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        {isSubmitting && (
                          <TailSpin className="h-4 " speed="1" />
                        )}
                        Confirmar
                      </button>

                      <button
                        onClick={() => {
                          setShowValidacao(false);
                          alteraTokenTelefone("");
                          alteraTokenEmail("");
                          alteraCodigo("");
                        }}
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Cancelar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
      {codigo !== "" && showToken && passo === 1 && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center lg:items-end lg:justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="w-full inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-4xl">
              <Formik
                initialValues={{
                  telefone: "",
                  email: "",
                  alteraCelular: false,
                  alteraEmail: false,
                }}
                validationSchema={tokenSchema}
                onSubmit={async (values, { setSubmitting }) => {
                  await tokenSubmit(values);
                  setSubmitting(false);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  isSubmitting,
                  setFieldValue,
                }: any) => (
                  <Form className="w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 text-green-800 sm:mx-0 sm:h-10 sm:w-10">
                          <FiSend />
                        </div>
                        <div className="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <h3
                            className="text-lg leading-6 font-medium text-gray-900 text-left"
                            id="modal-title"
                          >
                            Enviar token de desbloqueio:
                          </h3>
                          <p
                            className="my-3 text-md font-light leading-relaxed text-gray-700 text-left"
                            dangerouslySetInnerHTML={{
                              __html: tokenMensagem,
                            }}
                          ></p>
                          <div className="mt-2">
                            {erroToken !== "" && erroToken !== null && (
                              <div className="w-full mx-auto bg-red-700 text-white border border-red-200 rounded-lg shadow-xl my-4 ">
                                <div className="flex items-center justify-between px-6 py-2 mx-auto ">
                                  <div className="flex items-center">
                                    <AiOutlineWarning color="white" />
                                    <p className="pl-2 text-sm font-semibold tracking-wide uppercase">
                                      {erroToken}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {sucessoToken !== "" && sucessoToken !== null && (
                              <div className="w-full mx-auto text-white bg-green-700 border border-green-200 rounded-lg shadow-xl my-4 ">
                                <div className="flex items-center justify-between px-6 py-2 mx-auto ">
                                  <div className="flex items-center">
                                    <AiOutlineCheckCircle color="white" />
                                    <p className="pl-2 text-sm font-semibold tracking-wide uppercase">
                                      {sucessoToken}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          {(sucessoTokenSms == "" ||
                            sucessoTokenSms === null) && (
                            <div className="mt-2">
                              <h1 className="text-lg leading-6 font-medium text-gray-900 text-left">
                                Confirme o número do seu celular
                              </h1>
                              <label
                                htmlFor="telefone"
                                className="block text-theme text-base font-semibold leading-7 text-left"
                              >
                                Celular: {resultValidacao?.telefone}
                              </label>
                              <label className="flex flex-shrink items-center text-sm leading-7">
                                <Field
                                  type="checkbox"
                                  name="alteraCelular"
                                  className="mr-2"
                                />
                                Enviar token para outro número
                              </label>
                              {values.alteraCelular && (
                                <>
                                  <Field
                                    id="telefone"
                                    name="telefone"
                                    placeholder=""
                                    onChange={(e: any) => {
                                      setFieldValue(
                                        "telefone",
                                        phoneMask(e.target.value)
                                      );
                                      alteraCelularToken(
                                        phoneMask(e.target.value)
                                      );
                                    }}
                                    className="w-full px-4 py-2 mt-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                  />
                                  <div className="text-red-500 text-sm leading-7">
                                    {errors.telefone && touched.telefone
                                      ? errors.telefone
                                      : null}
                                  </div>
                                </>
                              )}

                              {erroTokenSms !== "" && erroTokenSms !== null && (
                                <div className="w-full lg:w-2/4 bg-red-700 text-white border border-red-200 rounded-lg shadow-xl my-4 ">
                                  <div className="flex items-center justify-between px-6 py-2 mx-auto ">
                                    <div className="flex items-center">
                                      <AiOutlineWarning color="white" />
                                      <p className="pl-2 text-sm font-semibold tracking-wide uppercase ">
                                        {erroTokenSms}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {sucessoTokenSms !== "" &&
                                sucessoTokenSms !== null && (
                                  <div className="w-full lg:w-2/4 bg-green-700 text-white border border-green-200 rounded-lg shadow-xl my-4 ">
                                    <div className="flex items-center justify-between px-6 py-2 mx-auto ">
                                      <div className="flex items-center">
                                        <AiOutlineCheckCircle color="white" />
                                        <p className="pl-2 text-sm font-semibold tracking-wide uppercase ">
                                          {sucessoTokenSms}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              {showConfirmToken && (
                                <div className="flex mt-4 flex-col gap-2 mb-2 lg:flex-row items-center">
                                  <div className="w-full lg:w-1/2">
                                    <div className="relative">
                                      <input
                                        readOnly={
                                          tokenSmsLoading ||
                                          tokenEmailLoading ||
                                          tTelefone !== ""
                                        }
                                        onChange={(e) =>
                                          setTokenSms(e.target.value)
                                        }
                                        value={tokenSms}
                                        type="text"
                                        name="token"
                                        placeholder="Digite o token do celular"
                                        className="w-full px-4 py-2 text-base text-black transition duration-500 ease-in-out transform border rounded-lg border-gray-300  focus:border-theme focus:bg-white focus:outline-none focus:shadow-outline ring-offset-current ring-offset-2"
                                      />
                                    </div>
                                  </div>
                                  <div className="w-full lg:w-1/2">
                                    <div className="relative">
                                      {tTelefone === "" && tokenEnviado && (
                                        <button
                                          disabled={
                                            tokenSms.length === 0 ||
                                            tokenSmsLoading ||
                                            tokenEmailLoading
                                          }
                                          onClick={() => validaTokenSms()}
                                          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                                        >
                                          {tokenSmsLoading && (
                                            <TailSpin
                                              className="h-4 "
                                              speed="1"
                                            />
                                          )}
                                          Validar
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        disabled={
                          loadingToken ||
                          isSubmitting ||
                          tokenEmailLoading ||
                          tokenEmailLoading
                        }
                        type="submit"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        {(isSubmitting || loadingToken) && (
                          <TailSpin className="h-4 " speed="1" />
                        )}
                        {(values.alteraCelular || values.alteraEmail) &&
                          "Salvar contatos e "}
                        {(sucessoTokenSms == "" || sucessoTokenSms === null) &&
                          "Enviar token para o celular"}
                        {sucessoTokenSms && "Enviar token para o email"}
                      </button>

                      <button
                        onClick={() => {
                          cancelar();
                        }}
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Cancelar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListarCartoes;
